module.exports = __webpack_public_path__ + "img/feature_7.d07e3e91.png";